<template>
<span>
  <v-card class="pa-6 ma-md-10 bg-white-show-through">

    <!-- title -->
    <v-card-title class="card-title">
      <v-icon large class="indigo--text mr-3">{{$t('sadmin.tenant_list.icon')}}</v-icon>
      {{ $t('sadmin.tenant_list.title')}}
    </v-card-title>

    <v-divider class="my-4"></v-divider>

    <v-card-text>

      <v-row>

        <v-col cols="12">

        <!--  <AppAlert v-if="error" :alert="alert"/> -->

          <v-skeleton-loader v-if="isLoading" v-bind="attrs" type="list-item-three-line"
                             style="height:8em;"></v-skeleton-loader>

          <v-simple-table v-if="!isLoading">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">{{$t('sadmin.tenant_list.name_label')}}</th>
                <th class="text-left">{{$t('sadmin.tenant_list.type_label')}}</th>
                <th class="text-left">{{$t('sadmin.tenant_list.status_label')}}</th>
                <th class="text-left">{{$t('sadmin.tenant_list.created_by_label')}}</th>
                <th class="text-left">{{$t('sadmin.tenant_list.created_at_label')}}</th>
                <th class="text-left">{{$t('sadmin.tenant_list.managers_label')}}
                <th class="text-left">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="tenant in tenants" :key="tenant.id">
                <td>{{ tenant.name }}</td>
                <td>{{ tenant.type }}</td>
                <td>{{ tenant.status }}</td>
                <td>{{ tenant.creator }}</td>
                <td>{{ tenant.created }}</td>
                <td style="max-width:400px;">
                  <v-chip class="ma-2" outlined color="blue" label
                          close close-label="Remove" @click:close="removeUserFromTenant(tenant,user)"
                          for v-for="user in tenant.users" :key="user.id"                          >
                    {{user.email}}
                  </v-chip>
                </td>
                   <td>   <v-btn class="mx-2" fab dark small color="warning" v-on:click="addUser(tenant)">
                                  <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                   </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-col>

      </v-row>

    </v-card-text>

  </v-card>


  <v-dialog v-model="dialog" width="500">

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{$t('sadmin.tenant_list.add_user')}}
      </v-card-title>

      <v-card-text>

          <v-autocomplete
                  v-model="selectedUser"
                  :loading="isLoadingPopup"
                  :items="foundUsers"
                  :search-input.sync="searchUsers"
                  cache-items
                  class="mx-4"
                  flat
                  hide-no-data
                  hide-details
                  label="Search user ?"
                  item-text="email"
                  item-value="id"
                  placeholder="Start typing to Search"
                  prepend-icon="mdi-database-search"
                  solo-inverted
          ></v-autocomplete>

        You need to disconnect the user to apply tenant membership updates.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="addUserToTenant()"> Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</span>


</template>

<script>
  import { TenantsApi } from '../../../shared/services/api/tenants'
  import { UsersApi } from '../../../shared/services/api/users'

  export default {
    data () {
      return {
        tenants: null,
        selectedTenant: null,
        selectedUser: null,
        foundUsers: [],
        searchUsers: null,
        attrs: {
          class: 'mb-6',
          boilerplate: true,
          elevation: 2
        },
        isLoading: false,
        isLoadingPopup: false,
        error: null,
        dialog: false
      };
    },
    methods: {
      findTenants () {
        this.isLoading = true;
        TenantsApi.getTenants()
          .then(tenants => this.tenants = tenants)
          .catch(error => this.error = error)
          .finally(() => this.isLoading = false);
      },
      addUser (objet) {
        console.log('Edit ', objet);
        this.dialog = true;
        this.selectedTenant = objet;
      },
      addUserToTenant () {
        console.debug('addUserToTenant ', this.selectedTenant, this.selectedUser);
        this.dialog = false;
        TenantsApi.addUserToTenant(this.selectedTenant.id, this.selectedUser)
          .then(this.findTenants())
          .catch(error => this.error = error)
          .finally(() => {
          });
      },
      removeUserFromTenant (tenant, user) {
        console.debug('removeUserFromTenant ', user);
        this.dialog = false;
        TenantsApi.deleteUserFromTenant(tenant.id, user.id)
          .then(this.findTenants())
          .catch(error => this.error = error)
          .finally(() => {
            this.findTenants()
          });
      },
    },
    mounted () {
      this.findTenants();
    },
    watch: {
      searchUsers (val) {
        console.log('findUsers ', val);
        this.isLoadingPopup = true
        UsersApi.findUsers(val)
          .then(users => this.foundUsers = users)
          .catch(error => this.error = error)
          .finally(() => this.isLoadingPopup = false);
      },
    },
  };
</script>

